module.exports = __webpack_public_path__ + "img/矩形 30 拷贝(1).6d51c4f2.png";